export default __webpack_public_path__ + "f03c3fcad8a9b545ceee053512f1a5d5.ttf";